import "core-js/modules/es.string.link.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-7dc485b3"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "upKey"
  }, " UP ", -1);
});

var _hoisted_2 = {
  class: "overall-header"
};
var _hoisted_3 = {
  id: "reveal-heard",
  class: "overall-header-left"
};
var _hoisted_4 = {
  class: "text-title"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "typing"
  }, null, -1);
});

var _hoisted_6 = {
  class: "text-sign"
};
var _hoisted_7 = {
  class: "text-content"
};
var _hoisted_8 = ["href"];
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  class: "overall-header-right lazyBackground"
};
var _hoisted_11 = {
  id: "reveal-heard",
  class: "overall-header-buttom"
};
var _hoisted_12 = {
  class: "introduction"
};
var _hoisted_13 = {
  id: "reveal-introduce",
  class: "my_image_Exercise"
};
var _hoisted_14 = {
  class: "my_Exercise"
};
var _hoisted_15 = {
  key: 0,
  class: "my_Exercise_text"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode("姓名: ");

var _hoisted_17 = {
  class: "my_Exercise_number"
};
var _hoisted_18 = {
  key: 1,
  class: "my_Exercise_text"
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode("职位: ");

var _hoisted_20 = {
  class: "my_Exercise_number"
};
var _hoisted_21 = {
  key: 2,
  class: "my_Exercise_text"
};

var _hoisted_22 = /*#__PURE__*/_createTextVNode("邮箱: ");

var _hoisted_23 = {
  class: "my_Exercise_number"
};
var _hoisted_24 = {
  key: 3,
  class: "my_Exercise_text"
};

var _hoisted_25 = /*#__PURE__*/_createTextVNode("电话: ");

var _hoisted_26 = {
  class: "my_Exercise_number"
};
var _hoisted_27 = {
  key: 4,
  class: "my_Exercise_text"
};

var _hoisted_28 = /*#__PURE__*/_createTextVNode("毕业院校: ");

var _hoisted_29 = {
  class: "my_Exercise_number"
};
var _hoisted_30 = {
  class: "my_image"
};
var _hoisted_31 = {
  style: {
    "width": "100%"
  }
};
var _hoisted_32 = {
  id: "reveal-introduce",
  class: "content_text"
};

var _hoisted_33 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "about_me"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "about_me_title"
  }, "关于我")], -1);
});

var _hoisted_34 = {
  class: "about_me_content"
};
var _hoisted_35 = {
  id: "reveal-heard",
  class: "my_job_buttom"
};
var _hoisted_36 = {
  class: "experience"
};
var _hoisted_37 = {
  id: "reveal-experience",
  class: "tree_box"
};

var _hoisted_38 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "about_me"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "about_me_title"
  }, "技能树")], -1);
});

var _hoisted_39 = {
  class: "my_tree_card"
};
var _hoisted_40 = {
  class: "skill_points"
};
var _hoisted_41 = {
  key: 0,
  class: "skill_web"
};
var _hoisted_42 = {
  class: "skill_web_text"
};
var _hoisted_43 = {
  class: "percentage"
};

var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "%", -1);
});

var _hoisted_45 = {
  class: "suject"
};
var _hoisted_46 = {
  class: "frame"
};
var _hoisted_47 = {
  key: 1,
  class: "skill_end"
};
var _hoisted_48 = {
  class: "skill_web_text"
};
var _hoisted_49 = {
  class: "percentage"
};

var _hoisted_50 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "%", -1);
});

var _hoisted_51 = {
  class: "suject"
};
var _hoisted_52 = {
  class: "frame"
};
var _hoisted_53 = {
  key: 2,
  class: "skill_linux"
};
var _hoisted_54 = {
  class: "skill_web_text"
};
var _hoisted_55 = {
  class: "percentage"
};

var _hoisted_56 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "%", -1);
});

var _hoisted_57 = {
  class: "suject"
};
var _hoisted_58 = {
  class: "frame"
};
var _hoisted_59 = {
  class: "skill_Progress"
};
var _hoisted_60 = {
  class: "skill_Progress_content_text"
};
var _hoisted_61 = {
  class: "Progress"
};
var _hoisted_62 = {
  id: "reveal-introduce",
  class: "my_job_content"
};

var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "my_job_title"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "about_me"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "about_me_title"
  }, "工作经历")])], -1);
});

var _hoisted_64 = {
  class: "job_card_container"
};
var _hoisted_65 = {
  class: "card_background lazyBackground"
};
var _hoisted_66 = {
  class: "job_content my_Exercise"
};
var _hoisted_67 = {
  key: 0,
  class: "job_content_image"
};
var _hoisted_68 = {
  class: "my_Exercise_text_job"
};

var _hoisted_69 = /*#__PURE__*/_createTextVNode("公司: ");

var _hoisted_70 = {
  class: "my_Exercise_number_job"
};
var _hoisted_71 = {
  class: "my_Exercise_text_job"
};

var _hoisted_72 = /*#__PURE__*/_createTextVNode("职位: ");

var _hoisted_73 = {
  class: "my_Exercise_number_job"
};
var _hoisted_74 = {
  class: "my_Exercise_text_job"
};

var _hoisted_75 = /*#__PURE__*/_createTextVNode("时间: ");

var _hoisted_76 = {
  class: "my_Exercise_number_job"
};
var _hoisted_77 = {
  id: "reveal-introduce",
  class: "experience_buttom"
};
var _hoisted_78 = {
  class: "my_project"
};

var _hoisted_79 = /*#__PURE__*/_createStaticVNode("<div class=\"my_project_background\" data-v-7dc485b3><div class=\"g-polygon-1\" data-v-7dc485b3></div><div class=\"g-polygon-2\" data-v-7dc485b3></div><div class=\"g-polygon-3\" data-v-7dc485b3></div></div><div id=\"reveal-project\" class=\"my_job_title\" data-v-7dc485b3><div class=\"about_me\" data-v-7dc485b3><span class=\"about_me_title\" data-v-7dc485b3>项目经历</span></div></div>", 2);

var _hoisted_81 = {
  class: "my_project_content"
};
var _hoisted_82 = {
  id: "reveal-project",
  class: "my_project_content_flex"
};
var _hoisted_83 = {
  lazy: "",
  class: "my_project_box_img"
};
var _hoisted_84 = {
  class: "my_project_box_text"
};
var _hoisted_85 = {
  class: "my_project_title"
};

var _hoisted_86 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "my_project_Universal"
  }, "项目简介： ", -1);
});

var _hoisted_87 = {
  class: "my_project_Introduction"
};

var _hoisted_88 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "my_project_Universal"
  }, "技术栈： ", -1);
});

var _hoisted_89 = {
  class: "my_project_Technology"
};
var _hoisted_90 = {
  class: "experience_buttom"
};
var _hoisted_91 = ["onClick"];
var _hoisted_92 = {
  id: "reveal-project",
  class: "experience_buttom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_backtop = _resolveComponent("el-backtop");

  var _component_vuetyped = _resolveComponent("vuetyped");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_tooltip = _resolveComponent("el-tooltip");

  var _component_count_to = _resolveComponent("count-to");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_theEnd = _resolveComponent("theEnd");

  var _component_checkProject = _resolveComponent("checkProject");

  var _directive_lazy = _resolveDirective("lazy");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_backtop, {
    bottom: 100
  }, {
    default: _withCtx(function () {
      return [_hoisted_1];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_vuetyped, {
    strings: _ctx.$t.my_typewriter,
    loop: true,
    "smart-backspace": true,
    "type-speed": 120,
    "start-delay": 1000
  }, {
    default: _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  }, 8, ["strings"])]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t.my_sign), 1), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$t.my_Link, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "text-content-svg"
    }, [_createVNode(_component_el_tooltip, {
      content: item.title || '我没写',
      placement: "bottom",
      effect: "light"
    }, {
      default: _withCtx(function () {
        return [_createElementVNode("a", {
          href: item.link,
          target: "_black"
        }, [_createVNode(_component_SvgIcon, {
          "icon-class": item.svg
        }, null, 8, ["icon-class"])], 8, _hoisted_8)];
      }),
      _: 2
    }, 1032, ["content"])]);
  }), 128)), _ctx.$t.loveThis ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_tooltip, {
    content: "我喜欢这个简历",
    placement: "bottom",
    effect: "light"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: _normalizeClass(['loveBox', 'loveRed', _ctx.loveState ? 'loveBoxAdm' : '']),
        onClick: _cache[0] || (_cache[0] = function () {
          return $setup.loveThis && $setup.loveThis.apply($setup, arguments);
        })
      }, null, 2)];
    }),
    _: 1
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "buttomDiv buttonFlex hvr-bounce-to-top hvr-buzz-out",
    onClick: _cache[1] || (_cache[1] = function () {
      return $setup.gotoCV && $setup.gotoCV.apply($setup, arguments);
    })
  }, "查看我的简历")]), _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [[_directive_lazy, _ctx.$t.rightImage, "background-image"]]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "buttomDiv buttonFlex hvr-bounce-to-bottom hvr-wobble-horizontal",
    onClick: _cache[2] || (_cache[2] = function () {
      return $setup.gotoIntroduction && $setup.gotoIntroduction.apply($setup, arguments);
    })
  }, "继续浏览")])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_ctx.$t.my_name !== '' && _ctx.$t.my_name ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t.my_name), 1)])) : _createCommentVNode("", true), _ctx.$t.my_Position !== '' && _ctx.$t.my_Position ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t.my_Position), 1)])) : _createCommentVNode("", true), _ctx.$t.my_mail !== '' && _ctx.$t.my_mail ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t.my_mail), 1)])) : _createCommentVNode("", true), _ctx.$t.my_phone !== '' && _ctx.$t.my_phone ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t.my_phone), 1)])) : _createCommentVNode("", true), _ctx.$t.my_colleges !== '' && _ctx.$t.my_colleges ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t.my_colleges), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_30, [_withDirectives(_createElementVNode("img", _hoisted_31, null, 512), [[_directive_lazy, _ctx.$t.my_photo]])])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, "  " + _toDisplayString(_ctx.$t.my_about), 1)]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
    class: "buttomDiv buttonFlex hvr-wobble-vertical hvr-bounce-to-right",
    onClick: _cache[3] || (_cache[3] = function () {
      return $setup.gotoExperience && $setup.gotoExperience.apply($setup, arguments);
    })
  }, "继续浏览")])]), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_ctx.$t.my_web.show ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createVNode(_component_count_to, {
    ref: "webPercentage",
    "start-val": 0,
    "end-val": _ctx.$t.my_web.percentage,
    duration: 8000,
    autoplay: false
  }, null, 8, ["end-val"]), _hoisted_44]), _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t.my_web.title), 1), _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t.my_web.context), 1)]), _createVNode(_component_SvgIcon, {
    "icon-class": "HTML5",
    class: "webCard"
  })])) : _createCommentVNode("", true), _ctx.$t.my_java.show ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_count_to, {
    ref: "javaPercentage",
    "start-val": 0,
    "end-val": _ctx.$t.my_java.percentage,
    duration: 8000,
    autoplay: false
  }, null, 8, ["end-val"]), _hoisted_50]), _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t.my_java.title), 1), _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t.my_java.context), 1)]), _createVNode(_component_SvgIcon, {
    "icon-class": "java",
    class: "webCard"
  })])) : _createCommentVNode("", true), _ctx.$t.my_linux.show ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_count_to, {
    ref: "linuxPercentage",
    "start-val": 0,
    "end-val": _ctx.$t.my_linux.percentage,
    duration: 8000,
    autoplay: false
  }, null, 8, ["end-val"]), _hoisted_56]), _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t.my_linux.title), 1), _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t.my_linux.context), 1)]), _createVNode(_component_SvgIcon, {
    "icon-class": "linux",
    class: "webCard"
  })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_59, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$t.my_Skill, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "skill_Progress_content"
    }, [_createElementVNode("div", _hoisted_60, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_61, [_createVNode(_component_el_tooltip, {
      content: item.introduce || '没有介绍',
      placement: "top",
      effect: "dark"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_progress, {
          "text-inside": true,
          "stroke-width": 18,
          color: item.color,
          percentage: item.percentage
        }, null, 8, ["color", "percentage"])];
      }),
      _: 2
    }, 1032, ["content"])])]);
  }), 128))])])]), _createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$t.my_experience, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "job_card"
    }, [_withDirectives(_createElementVNode("div", _hoisted_65, null, 512), [[_directive_lazy, item.cardBackground, "background-image"]]), _createElementVNode("div", _hoisted_66, [item.image ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_67, null, 512)), [[_directive_lazy, item.image]]) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_68, [_hoisted_69, _createElementVNode("span", _hoisted_70, _toDisplayString(item.titles), 1)]), _createElementVNode("div", _hoisted_71, [_hoisted_72, _createElementVNode("span", _hoisted_73, _toDisplayString(item.post), 1)]), _createElementVNode("div", _hoisted_74, [_hoisted_75, _createElementVNode("span", _hoisted_76, _toDisplayString(item.time), 1)])])]);
  }), 128))])]), _createElementVNode("div", _hoisted_77, [_createElementVNode("div", {
    class: "buttomDiv buttonFlex hvr-wobble-to-bottom-right hvr-bounce-to-left",
    onClick: _cache[4] || (_cache[4] = function () {
      return $setup.gotoProject && $setup.gotoProject.apply($setup, arguments);
    })
  }, "继续浏览")])]), _createElementVNode("div", _hoisted_78, [_hoisted_79, _createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$t.my_project, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "my_project_box"
    }, [_withDirectives(_createElementVNode("img", _hoisted_83, null, 512), [[_directive_lazy, item.cardBackground]]), _createElementVNode("div", _hoisted_84, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_85, _toDisplayString(item.project_title), 1), _hoisted_86, _createElementVNode("div", _hoisted_87, _toDisplayString(item.project_Introduction), 1), _hoisted_88, _createElementVNode("div", _hoisted_89, _toDisplayString(item.project_software), 1), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", {
      class: "buttomDiv buttonFlex hvr-back-pulse",
      onClick: function onClick($event) {
        return $setup.checkProject(item);
      }
    }, "查看详情", 8, _hoisted_91)])])])]);
  }), 128))])]), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", {
    class: "buttomDiv buttonFlex hvr-shutter-in-horizontal",
    onClick: _cache[5] || (_cache[5] = function () {
      return $setup.gotoTheEnd && $setup.gotoTheEnd.apply($setup, arguments);
    })
  }, "继续浏览")])]), _createVNode(_component_theEnd), _createVNode(_component_checkProject, {
    modelValue: $setup.state.showDialog,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $setup.state.showDialog = $event;
    }),
    content: _ctx.my_project_son,
    "onUpdate:content": _cache[7] || (_cache[7] = function ($event) {
      return _ctx.my_project_son = $event;
    })
  }, null, 8, ["modelValue", "content"])]);
}